import {Button, Col, Form, Input, InputNumber, Row} from 'antd';
import React, {useContext} from 'react';
import {sideMenuContext} from '../../../router/IndexRouter';
import {validateWhiteSpace} from '../common/ValidateWhiteSpace';

const layout = {
	labelCol: {span: 8},
	wrapperCol: {span: 16},
};
const tailLayout = {
	wrapperCol: {offset: 4, span: 16},
};

const DetailBaseRecognition = () => {
	const {currentItem} = useContext(sideMenuContext);
	const [form] = Form.useForm();

	return (
		<Form
			{...layout}
			form={form}
			initialValues={currentItem}
			style={{maxWidth: 1200, marginLeft: 40}}
		>
			<Row align="top">
				<Col span={12}>
					<Form.Item name="commendYear" label="表彰年度"
							   rules={[{required: true, message: '内容不能为空'}]}>
						<InputNumber min={0} style={{width: 150}} disabled={true}/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="commendName" label="表彰名称"
							   rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input disabled={true}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="commendContent" label="说明" rules={[{required: true, message: '内容不能为空'}]}>
						<Input disabled={true}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="commendMemo" label="详细信息" rules={[{required: true, message: '内容不能为空'}]}>
						<div style={{marginTop: 4}} dangerouslySetInnerHTML={{__html: currentItem.commendMemo}}/>
					</Form.Item>
				</Col>
			</Row>

			<Form.Item {...tailLayout}>
				<Button
					type="primary"
					htmlType="button"
					onClick={() => {
						window.history.back();
					}}
				>
					返回
				</Button>
			</Form.Item>
		</Form>
	);
};

export default DetailBaseRecognition;